<template>
  <div class="app-sim-success">
    <div class="outer-wrapper">
      <slot v-if="this.isEsim" name="ceSubstituteESim"></slot>
      <slot v-else-if="this.isPreActivated"  name="ceSubstituteSimActive"></slot>
      <slot v-else  name="ceSubstituteSimInactive"></slot>
    </div>
  </div>
</template>

<script>
import { substituteSimTracking } from '@/helper/checkoutTracking'

export default {
  name: 'Success',
  props: {
    isEsim: {
      type: Boolean,
      default: true
    }
  },
  mounted () {
    this.triggerConfirmTracking('success')
  },
  computed: {
    isPreActivated: function () {
      return this.$store.getters['checkoutv2/substituteSim/activated']
    }
  },
  methods: {
    triggerConfirmTracking () {
      substituteSimTracking(this.$store, 3)
    }
  }
}
</script>
